import React, { useContext, memo } from 'react'

import Title from 'components/CommonUI/Title/Title'
import SearchInput from 'components/CommonUI/SearchInput/SearchInput'

import { DeviceContext } from '../DeviceConnectionContainer'

const SearchSection = () => {
  const { actions, state } = useContext(DeviceContext)

  return (
    <div className="search_section_container">
      <Title
        title="Drag devices to channels"
        component="h2"
        className="search_title"
      />
      <SearchInput
        placeholder="Search device by name"
        classNameContainer="search_input"
        value={state.searchDeviceValue}
        handleChange={actions.setSearchDeviceValue}
      />
    </div>
  )
}

export default memo(SearchSection)
